import { Button, ChakraStyledOptions } from "@chakra-ui/react";

import styles from "./CustomBlueButton.module.scss";

type LoginButtonProps = ChakraStyledOptions;

export default function CustomBlueButton({
  w,
  children,
  ...props
}: LoginButtonProps) {
  return (
    <Button colorScheme="blue" w={w} {...props} className={styles.button}>
      {children}
    </Button>
  );
}
